export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <circle cx="16" cy="16" r="15.25" fill="#1B1F23" stroke="#262B30" strokeWidth="1.5" />
      <path
        d="M14.31 21.58 A5.5 5.5 0 0 0 10.42 17.69"
        stroke="#F2F1EE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18.66 20.41 A10 10 0 0 0 11.59 13.34"
        stroke="#F2F1EE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23 19.25 A14.5 14.5 0 0 0 12.75 9"
        stroke="#F2F1EE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="9" cy="23" r="2.6" fill="#FF6A1A" />
    </svg>
  );
}

export default function Logo({ size = 32 }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark size={size} />
      <span className="text-[16.5px] font-semibold tracking-[-0.01em] text-cream">
        Clearriver Studios
      </span>
    </span>
  );
}
